export default {
  name: "Avis",
  plural: "Avis",
};
